import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { connect } from 'react-redux'
import { factsheetActions } from '../../../../../redux/actions/factsheet'

const COMPONENT_MAP = {
  'section:header': 'section-header',
  'section:box': 'section-box-2-column-alternative',
  'section:box-1-column': 'section-box-1-column',
  'section:box-2-column': 'section-box-2-column-alternative',
  'section:separator': 'section-separator',
  'fact:checkbox': 'fact-checkbox',
  'attribute:input': 'attribute-input',
  'attribute:input-w-unit': 'attribute-input-with-unit',
  'attribute:checkbox': 'attribute-checkbox',
  'attribute:single-attribute-select': 'attribute-single-select',
  'attribute:single-value-select': 'attribute-single-value-select',
  'attribute:multi-attribute-select-pills': 'attribute-multi-select-pills',
  'attribute:daterange-select': 'attribute-daterange-select',
  'attribute:hours': 'attribute-hours',
  'attribute:time': 'attribute-time',
  'attribute:currency-selector': 'attribute-currency-selector',
  'attribute:hidden': 'attribute-hidden',
  'fact:hidden': 'fact-hidden',
  'fact:single-attribute-controlled': 'fact-single-attribute-controlled',
  'attribute:price-input': 'attribute-price-input',
  'group:single-attribute-select-controlled-pricing': 'group-single-attribute-select-controlled-pricing',
  'attribute:single-select-price-input': 'attribute-single-select-price-input',
}

const components = {}

class ComponentLoader extends PureComponent {
  getComponentName (type) {
    if (COMPONENT_MAP[type]) {
      return COMPONENT_MAP[type]
    }
    return null
  }

  load (componentName) {
    if (componentName === null) {
      return null
    }
    if (components[componentName]) {
      return components[componentName]
    }

    let component
    try {
      component = require('./../' + componentName).default
    } catch (err) {
      throw new Error('Failed to require component ' + componentName)
    }
    components[componentName] = component
    return component
  }

  deleteAttribute = (...args) => {
    this.props.deleteAttribute(...args)
    this.props.afterDeleteAttribute && this.props.afterDeleteAttribute(...args)
  }

  render () {
    let componentName = this.getComponentName(this.props.blueprint.type)
    if (componentName === null) {
      return <div>Unknown component type {this.props.blueprint.type}</div>
    }
    const Component = this.load(componentName)
    let data = undefined
    let validationStatus = undefined
    switch (componentName) {
      case 'fact-checkbox':
      case 'fact-single-attribute-controlled':
        if (this.props.factsheet.facts.hasOwnProperty(this.props.blueprint.id)) {
          data = this.props.factsheet.facts[this.props.blueprint.id]
        }
        if (this.props.factsheet.validation.facts.hasOwnProperty(this.props.blueprint.id)) {
          validationStatus = this.props.factsheet.validation.facts[this.props.blueprint.id]
        }
        return <Component
          data={data}
          validationStatus={validationStatus}
          deleteFact={this.props.deleteFact}
          addFactInstance={this.props.addFactInstance}
          putFactInstance={this.props.putFactInstance}
          deleteFactInstance={this.props.deleteFactInstance}
          putFactInstanceExpandedStatus={this.props.putFactInstanceExpandedStatus}
          blueprint={this.props.blueprint}
          expandedFactInstances={
            this.props.factsheet.expandedFactInstances[this.props.blueprint.id]
          }
          factsheetBlueprint={this.props.factsheetBlueprint}/>
      case 'attribute-input':
      case 'attribute-input-with-unit':
      case 'attribute-checkbox':
      case 'attribute-single-select':
      case 'attribute-single-value-select':
      case 'attribute-multi-select-pills':
      case 'attribute-daterange-select':
      case 'attribute-hours':
      case 'attribute-time':
      case 'attribute-currency-selector':
      case 'attribute-price-input':
      case 'group-single-attribute-select-controlled-pricing':
      case 'attribute-single-select-price-input':
        if (this.props.factsheet.facts.hasOwnProperty(this.props.parentBlueprint.id)) {
          switch (componentName) {
            case 'attribute-single-select':
            case 'attribute-multi-select-pills':
            case 'group-single-attribute-select-controlled-pricing':
            case 'attribute-single-select-price-input':
              data = this.props.factsheet.facts[this.props.parentBlueprint.id][this.props.factInstanceKey]
              break
            default:
              if (
                this.props.factsheet.facts[this.props.parentBlueprint.id][this.props.factInstanceKey].hasOwnProperty('attributes')
                && this.props.factsheet.facts[this.props.parentBlueprint.id][this.props.factInstanceKey].attributes.hasOwnProperty(
                  this.props.blueprint.id
                )) {
                data = this.props.factsheet.facts[this.props.parentBlueprint.id][this.props.factInstanceKey].attributes[this.props.blueprint.id]
              }
          }
        }
        return <Component
          blueprint={this.props.blueprint}
          parentBlueprint={this.props.parentBlueprint}
          factInstanceKey={this.props.factInstanceKey}
          data={data}
          collapsed={this.props.collapsed}
          putAttribute={this.props.putAttribute}
          deleteAttribute={this.deleteAttribute}
          putValidationStatus={this.props.putValidationStatus}
          factsheetBlueprint={this.props.factsheetBlueprint}
        />
      default:
        break
    }
    return <Component
      blueprint={this.props.blueprint}
      parentBlueprint={this.props.parentBlueprint}
      factsheetBlueprint={this.props.factsheetBlueprint}/>
  }
}

ComponentLoader.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.oneOfType([
    PropTypes.shape(SHAPE_COMPONENT),
    PropTypes.shape({ components: PropTypes.array.isRequired })
  ]).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number,
  collapsed: PropTypes.bool,
  afterDeleteAttribute: PropTypes.func,
}
const mapStateToProps = (state) => {
  return {
    factsheet: state.factsheet
  }
}

const mapDispatchToProps = {
  deleteFact: factsheetActions.deleteFact,
  putFactsheet: factsheetActions.putFactsheet,
  addFactInstance: factsheetActions.addFactInstance,
  putFactInstance: factsheetActions.putFactInstance,
  deleteFactInstance: factsheetActions.deleteFactInstance,
  putAttribute: factsheetActions.putAttribute,
  deleteAttribute: factsheetActions.deleteAttribute,
  putValidationStatus: factsheetActions.putValidationStatus,
  putFactInstanceExpandedStatus: factsheetActions.putFactInstanceExpandedStatus
}
export default connect(mapStateToProps, mapDispatchToProps)(ComponentLoader)
